export default __webpack_public_path__ + "images/circle-right-arrow.svg";